import { createAsyncThunk } from '@reduxjs/toolkit';
import apiConfig from 'constants/apiConfig';
import { fetchContacts } from 'services/api/creator-contacts';
import { AuthState } from 'slices/auth/reducer';
import { ERROR } from 'types';
import { Contact, CreatorContactsFilters, CreatorsReducerState } from 'types/creators';
import { generateUniqueKey, getErrorMessage, isFresh } from 'utils/helpers';

export const fetchContactsThunk = createAsyncThunk<
    {
        filterId: string;
        filters: CreatorContactsFilters;
        count: number;
        items: Contact[];
        unprocessed: number;
        failed: number;
    },
    { force?: boolean; filters: CreatorContactsFilters },
    { rejectValue: string }
>(
    'creators/fetchContacts',
    async ({ force = false, filters }, { getState, rejectWithValue }) => {
        try {
            const state = getState() as { auth: AuthState; creators: CreatorsReducerState };
            const agencyId = state.auth.selectedAgencyId;
            if (!agencyId) {
                throw new Error('No agency selected!');
            }
            const filterId = generateUniqueKey(filters, ['page']);
            const STALE_TIME = apiConfig.FETCH_CONTACTS.staleTime;
            if (
                filters.page === 1 &&
                !force &&
                isFresh(state.creators.filtered_lists?.[filterId]?.last_fetched_at, STALE_TIME)
            ) {
                return rejectWithValue(ERROR.CACHED);
            }
            const contacts = await fetchContacts(agencyId, filters);
            return {
                filterId,
                filters,
                count: contacts.count,
                items: contacts.items,
                unprocessed: contacts.unprocessed ?? 0,
                failed: contacts.failed ?? 0,
            };
        } catch (error) {
            return rejectWithValue(getErrorMessage(error, 'Failed to fetch contacts'));
        }
    }
);
